(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SearchBar',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var countRequest = null;

		// toggle advanced search button
		toggleAdvancedSearchButton($form.find('select#searchbar-type').val());

		// init dual calendar component
		// Adzuki.Web.DualCalendar.initOnForm($form);

		// Clear hidden destination fields if less than 2 chars in tour dest search
		// Show "No Results" if search text entered but hidden fields are empty
		$("#searchbar-tour_destination").on('keyup', function checkForDestination() {
			var $submit_btn  = $form.find('[type="submit"]');

			if ($("#searchbar-tour_destination").val().trim().length <= 1) {
				$form.find('#searchbar-tour_city_id').val('');
				$form.find('.tour-country-id').val('');

				if ($("#searchbar-tour_destination").val().trim().length === 0) {
					$form.change();
				} else {
					$submit_btn.html('No Results');
				}
			} else if ($('#searchbar-tour_city_id').val().trim() === '' && $('#searchbar-tour_country_id').val().trim() === '') {
				if (countRequest !== null) {
					countRequest.abort();
				}
				$submit_btn.html('No Results');
			}
		});

		Adzuki.Typeahead(
			'.tour-location-search',
			'/TourSearch/locations',
			function select(item) {
				$form.find('.tour-city-id').val(item.city_id);
				$form.find('.tour-country-id').val(item.country_id);
			}
		);

		$form.find('select#searchbar-type').on('change', function changeType() {
			$('.date-search').removeClass('hidden');

			if (this.value === 'package') {
				// get package destinations
				getDestinationList();

				// get package cruise lines
				getCruiseLineList(this.value);
				$('.date-search').removeClass('hidden');
			} else if (this.value === 'cruise') {
				// get regular cruise lines
				getCruiseLineList(this.value);
				$('.date-search').removeClass('hidden');
			} else if (this.value === 'tour') {
				$('.date-search').removeClass('hidden');
			} else if (this.value === 'properties') {
				$('.date-search').addClass('hidden');
			}

			$form.find('span.options').addClass('hidden');
			$form.find('span.options[data-type="'+this.value+'"]').removeClass('hidden');

			if (this.value === 'cruise' || this.value === 'package') {
				$form.find('span.options.cruise-fields').removeClass('hidden');
			} else {
				$form.find('span.options.cruise-fields').addClass('hidden');
			}

			toggleAdvancedSearchButton(this.value);
		});

		// when selecting a cruise line, update the ships select with ships
		$form.find('select.cruise-line').change(function cruiseLineChanged()
		{
			var $self        = $(this),
			    $this_form   = $self.parents('form'),
			    $ship_select = $this_form.find('select.ship'),
			    ship_data    = [],
			    sorted_data  = [],
			    search_path  = '/CruiseSearch/getShips/';

			if ($this_form.find('select#searchbar-type').val() === 'package') {
				search_path = '/Packages/getPackageShipList/';
			}

			Adzuki.Ajax.get(search_path + $self.val())
			.then(function populateShipSelect(data) {
				$ship_select.empty();
				ship_data.push($('<option>').text('Any Ship').attr('value', ''));

				sorted_data = Adzuki.Sort.alphabeticValue(data);
				$.each(sorted_data, function appendShipOption(sKey, sValue) {
					ship_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				$ship_select.append(ship_data);
			});
		});

		// when selecting a "from" date, change the "to" date to be +1 month
		$form.find("input.start-date").on('dp.change', function setEndDate(event, args) {
			// args.linked_dtp.date(args.date_obj.add(1, 'month'));
		});

		// when the form changes, get an updated itinerary count
		$form.on('change dp.change', Adzuki.Debounce(function updateItineraryCount() {
			var $self        = $(this),
			    $submit_btn  = $self.find('[type="submit"]'),
			    record_count = 0,
			    count_url    = '/CruiseSearch/getCount',
				search_type  = 'cruise';

			if ($self.find('select#searchbar-type').val() !== undefined) {
				if ($self.find('select#searchbar-type').val() === 'tour' || $self.find('#searchbar-type').val() === 'tour') {
					search_type = 'tour';
					count_url   = '/TourSearch/countResults';

					if (
						$('#searchbar-tour_destination').val().trim() !== ''
						&& $('#searchbar-tour_city_id').val().trim() === ''
						&& $('#searchbar-tour_country_id').val().trim() === '')
					{
						$submit_btn.html('No Results');
						return;
					}
				}

				if ($self.find('select#searchbar-type').val() === 'package' || $self.find('#searchbar-type').val() === 'package') {
					search_type = 'package';
					count_url   = '/Packages/countResults';
				}

				if ($self.find('select#searchbar-type').val() === 'properties' || $self.find('#searchbar-type').val() === 'properties') {
					search_type = 'properties';
					count_url   = '/AllInclusiveProperties/countResults';
				}

				$submit_btn
					.prop('disabled', true)
					.html('Searching...');

				countRequest = Adzuki.Ajax.post(count_url, $self.serialize());
				countRequest.then(function changeSubmitButtonText(data)
				{
					if (search_type === 'cruise') {
						record_count = parseInt(data[0].dynamic.count);
					}
					else if (search_type === 'tour') {
						record_count = parseInt(data.matched.replace(',', ''));
					}
					else if (search_type === 'package') {
						record_count = parseInt(data.count);
					}
					else if (search_type === 'properties') {
						record_count = parseInt(data.count);
					}

					if (record_count && record_count > 0) {
						record_count = accounting.format(record_count);
						$submit_btn
							.prop('disabled', false)
							.html('View Results (' + record_count + ')');
					}
					else {
						$submit_btn.html('No Results');
					}
				});
			}	
		}, 500));

		$form.find('button.btn-primary').click(function submitClicked()
		{
			$(this).html('<i class="' + Adzuki.FaIcon.getIconStyle('cog') + ' fa-spin fa-fw"></i> Getting results...');
		});


		// for selection changes made in the cruise search results filter form
		// when selecting a cruise line, update the ships select with ships
		$('#cruisesearchfilter-ships').change(function filterShipsChanged()
		{
			// filter ships changed, select all destinations
			$('#cruisesearchfilter-destinations').selectpicker('selectAll');
		});

		$('#cruisesearchfilter-destinations').change(function filterShipsChanged()
		{
			// filter destinations changed, select all departure ports
			$('#cruisesearchfilter-departure_ports').selectpicker('selectAll');
		});

		$('#cruisesearchfilter-departure_ports').change(function filterShipsChanged()
		{
			// filter departure ports changed, select all arrival ports
			$('#cruisesearchfilter-arrival_ports').selectpicker('selectAll');
		});

		// find a hotel stuff
		Adzuki.GooglePlaces($form.find('.google-places'));

		// This will stop the checkout date to change automatically
		$('#searchbar-checkin').on('dp.change', function populateDropoff(e) {
			var checkout_date = '';

			if ($('#searchbar-checkout').val() !== '') {
				checkout_date = Date.parse($('#searchbar-checkout').val());
			}

			if (
				e.date
				&& (
					checkout_date === '' ||
					checkout_date <= e.date
				)
			) {
				$('#searchbar-checkout').data('DateTimePicker').date(e.date.add(1, 'days'));
			}
		});

		// only show adult/children fields for the number of rooms selected
		$('#searchbar-num_rooms').on('change', function roomsChange(e) {
			var $self   = $(this),
			    room_ct = $self.val(),
			    i       = 1;

			// hide all rooms
			$('.room').addClass('hidden');

			// show # of rooms
			for (i; i <= room_ct; i++) {
				$('#room-' + i).removeClass('hidden');
			}
		});

		// only show age dropdowns for the number of children selected for the room
		$('.children-per-room').on('change', function childrenChange(e) {
			var $self       = $(this),
			    child_ct    = $self.val(),
			    $room       = $self.closest('.room'),
			    $child_ages = $room.find('.children-age'),
			    i           = 1;

			$child_ages.each(function showAges() {

				$(this).addClass('hidden');

				if (i <= child_ct) {
					$(this).removeClass('hidden');
				}

				i++;
			});
		});

		function getCruiseLineList(type)
		{
			var $cruise_line_select = $form.find('select#searchbar-bottom_cruise_lines'),
			    cruise_line_data    = [],
			    sorted_data         = [],
			    search_path         = '/CruiseSearch/getCruiseLinesForWebsite/';

			if (type === 'package') {
				search_path = '/Packages/getPackageCruiseLineList/';
			}

			Adzuki.Ajax.get(search_path)
			.then(function populateCruiseLineSelect(data) {
				$cruise_line_select.empty();
				cruise_line_data.push($('<option>').text('Any Cruise Line').attr('value', ''));

				if (type === 'package') {
					sorted_data = Adzuki.Sort.alphabeticValue(data);

					$.each(sorted_data, function appendCruiseLines(sKey, sValue) {
						cruise_line_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
					});
				} else {
					$.each(data, function parseCruiseLines(oKey, oValues) {
						var $optgroup        = $('<optgroup label="' + oKey + '">'),
						    cruise_line_list = Adzuki.Sort.alphabeticValue(oValues);

						$.each(cruise_line_list, function appendCruiseLines(sKey, sValue) {
							$optgroup.append($('<option>').text(sValue.value).attr('value', sValue.key));
						});

						cruise_line_data.push($optgroup);
					});
				}

				$cruise_line_select.append(cruise_line_data);
			});
		}

		function getDestinationList()
		{
			var $destination_select = $form.find('select.destination'),
			    destination_data    = [],
			    sorted_data         = [];

			Adzuki.Ajax.get('/Packages/getPackageDestinationList')
			.then(function populateDestinationSelect(data) {
				$destination_select.empty();
				destination_data.push($('<option>').text('Any Destination').attr('value', ''));

				sorted_data = Adzuki.Sort.alphabeticValue(data);
				$.each(sorted_data, function appendDestinationOption(sKey, sValue) {
					destination_data.push($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				$destination_select.append(destination_data);
			});
		}

		function toggleAdvancedSearchButton(search_type)
		{
			var advanced_button = $('aside#search .btn-advanced');

			// show advanced search button for cruise
			if (search_type === 'cruise') {
				advanced_button.removeClass('hidden');

				advanced_button.click(function advancedButton(e) {
					e.preventDefault();
					window.location.href = Adzuki.base_uri + '/CruiseSearch/AdvancedSearch/1';
				});
			} else {
				advanced_button.addClass('hidden');
			}
		}
	};

}(jQuery, window.Adzuki || {}));
